import { QRFC } from "./QRFC";

export class QRFCMgr {
  constructor() {
    this.fRFCQueue = null;
  }

  InitRFCMgr() {
    this.fRFCQueue = [];
  }

  QueueSize() {
    return this.fRFCQueue.length;
  }

  QueueRFC(rfc) {
    var q = this.fRFCQueue;
    if (!rfc.fIsAsync) this.fRFCQueue.push(rfc);
    rfc.fRFCMgr = this;
    if (q.length == 1 || rfc.fIsAsync) rfc.Send();
    //console.log("QueueRC:",q.length);
  }

  GetIndexRFC(idx) {
    return this.fRFCQueue[idx];
  }

  // If a RFC does not allow stacked trans then all RFCs that do now allow stacked transactions are dumped
  // If an RFC does allow stacked then the next RFC will execute as soon as the previous RFC completes
  // What this means is that any UI actions should be done on RFC complete
  // For example, a folder icon should only show as open after the RFC to list the folder directory completes
  StripDups(curRFC) {
    if (curRFC.AllowStacked()) return this.fRFCQueue;

    var q = this.fRFCQueue;
    var n = q.length;
    if (n == 0) return this.fRFCQueue;

    var strippedQ = [];
    var done = false;
    while (!done) {
      var nextTrans = q.shift();
      if (nextTrans == null) done = true;
      else {
        if (nextTrans.AllowStacked()) strippedQ.push(nextTrans);
      }
    }

    return strippedQ;
  }

  RFCComplete(rfc) {
    if (rfc.fIsAsync) return; //This whole thing is designed around handling a single queue.

    var q = this.fRFCQueue;
    var curRFC = q.shift();
    if (rfc != curRFC) {
      console.log("QRFCManager - RFCComplete - this should never happen!!");
    }

    this.fRFCQueue = this.StripDups(curRFC);
    if (this.fRFCQueue.length > 0) {
      var nextTrans = this.fRFCQueue[0];
      nextTrans.Send();
    }
  }
}
